import { normalizeText } from "../utils/normalize-excel-value";
export function convertDataSheetToProductData(dataSheet, showPrice) {
    const items = [];
    const headerRow = dataSheet.getRow(1);
    const headers = headerRow.values;
    dataSheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1)
            return; // 헤더 행 건너뛰기
        const item = {};
        headers.forEach((header, colNumber) => {
            if (!header)
                return;
            const cellValue = row.getCell(colNumber).value;
            switch (header) {
                case "종류":
                    item.type = normalizeText(cellValue?.toString() || "");
                    break;
                case "분류":
                    item.classification = normalizeText(cellValue?.toString() || "");
                    break;
                case "관리코드":
                    item.productCode = normalizeText(cellValue?.toString() || "");
                    break;
                case "제품명":
                    item.name = normalizeText(cellValue?.toString() || "");
                    break;
                case "모델명":
                    item.model = normalizeText(cellValue?.toString() || "");
                    break;
                case "사양":
                    item.spec = normalizeText(cellValue?.toString() || "");
                    break;
                case "제조사":
                    item.manufacturer = normalizeText(cellValue?.toString() || "");
                    break;
                case "위치":
                    item.spot = normalizeText(cellValue?.toString() || "");
                    break;
                case "재고":
                    item.stockNum =
                        typeof cellValue === "number" ? Math.round(cellValue) : 0;
                    break;
                case "단가":
                    item.unitPrice =
                        typeof cellValue === "number" && showPrice
                            ? Math.round(cellValue)
                            : 0;
                    break;
                case "단위":
                    item.quantityUnit = normalizeText(cellValue?.toString() || "");
                    break;
                case "상태":
                    item.conditions = normalizeText(cellValue?.toString() || "");
                    break;
            }
        });
        items.push(item);
    });
    return items;
}
